import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee685ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between mb-2 flex-wrap gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-color-secondary"
}
const _hoisted_3 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-document-outline dash-empty-icon" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No TCM results for this period yet.", -1))
const _hoisted_6 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-label mb-2" }, "Invoices for this period", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PTag = _resolveComponent("PTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WSubTitle, { text: "Settlement summary" }),
      (_ctx.tcm?.available)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.tcm.valid_hour_count) + " valid hour(s) · VAT " + _toDisplayString(_ctx.fmt(_ctx.tcm.vat)) + " SAR ", 1))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.tcm?.available)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          (_ctx.canRunTcm)
            ? (_openBlock(), _createBlock(_component_PButton, {
                key: 0,
                disabled: !_ctx.billingPeriodId || _ctx.runningTcm,
                loading: _ctx.runningTcm,
                class: "mt-2",
                icon: "pi pi-play",
                label: "Run TCM",
                rounded: "",
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('run-tcm')))
              }, null, 8, ["disabled", "loading"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_PDataTable, {
            rowHover: true,
            showGridlines: true,
            stripedRows: true,
            value: _ctx.tcm.variables,
            "data-key": "name",
            size: "small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PColumn, {
                field: "name",
                header: "Tag",
                sortable: ""
              }),
              _createVNode(_component_PColumn, {
                field: "value",
                header: "Value",
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.fmt(data.value)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PColumn, {
                field: "unit",
                header: "Unit",
                style: {"width":"5rem"}
              }),
              _createVNode(_component_PColumn, {
                field: "description",
                header: "Description"
              })
            ]),
            _: 1
          }, 8, ["value"]),
          (_ctx.invoices.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_PDataTable, {
                  rowHover: true,
                  showGridlines: true,
                  value: _ctx.invoices,
                  "data-key": "id",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PColumn, {
                      field: "invoice_number",
                      header: "Number"
                    }),
                    _createVNode(_component_PColumn, {
                      field: "status",
                      header: "Status",
                      style: {"width":"7rem"}
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode(_component_PTag, {
                          severity: data.status === 'approved' ? 'success' : 'warning'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.status), 1)
                          ]),
                          _: 2
                        }, 1032, ["severity"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_PColumn, {
                      field: "mode",
                      header: "Mode",
                      style: {"width":"6rem"}
                    }),
                    _createVNode(_component_PColumn, {
                      field: "pdf_filename",
                      header: "PDF"
                    }, {
                      body: _withCtx(({ data }) => [
                        (data.pdf_filename)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "cursor-pointer",
                              onClick: _withModifiers(($event: any) => (_ctx.downloadInvoice(data.pdf_filename)), ["prevent"])
                            }, _toDisplayString(data.pdf_filename), 9, _hoisted_8))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, "—"))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_PColumn, {
                      field: "generated_by",
                      header: "Generated by"
                    }),
                    _createVNode(_component_PColumn, {
                      field: "approved_by",
                      header: "Approved by"
                    }),
                    (_ctx.canApproveInvoice)
                      ? (_openBlock(), _createBlock(_component_PColumn, {
                          key: 0,
                          header: "",
                          style: {"width":"7rem"}
                        }, {
                          body: _withCtx(({ data }) => [
                            (data.status === 'draft')
                              ? (_openBlock(), _createBlock(_component_PButton, {
                                  key: 0,
                                  loading: _ctx.approvingId === data.id,
                                  icon: "pi pi-check",
                                  label: "Approve",
                                  rounded: "",
                                  size: "small",
                                  severity: "success",
                                  onClick: ($event: any) => (_ctx.$emit('approve-invoice', data.id))
                                }, null, 8, ["loading", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}